import { GENERATE_MEMBERSHIPS, GENERATE_MEMBERSHIPS_SUCCESS, GENERATE_MEMBERSHIPS_ERROR, GENERATE_MEMBERSHIPS_EMPTY } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GenerateMemberships = (state = initialState, action) => {
  switch (action.type) {
    case GENERATE_MEMBERSHIPS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GENERATE_MEMBERSHIPS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GENERATE_MEMBERSHIPS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GENERATE_MEMBERSHIPS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GenerateMemberships;
